import { InstallMeterStep } from '../enums/installMeterStep';

export const INSTALL_METER_STEPS_COUNT = Object.keys(InstallMeterStep).length / 2;
